<!--
  Copyright 2021 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>

  <h1 class="page-title" i18n="@@app.labels.surveys">Surveys</h1>

  <div class="filters-container">
    <mat-chip-set aria-label="Survey filter">
      <ng-container
        *ngTemplateOutlet="
          filterChip;
          context: { filter: SurveyListFilter.ALL }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          filterChip;
          context: { filter: SurveyListFilter.RESTRICTED, icon: 'lock' }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          filterChip;
          context: { filter: SurveyListFilter.UNLISTED, icon: 'account_circle' }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          filterChip;
          context: { filter: SurveyListFilter.PUBLIC, icon: 'public' }
        "
      ></ng-container>
    </mat-chip-set>
  </div>

  <div class="surveys-container">
    <mat-card
      appearance="raised"
      id="add-card"
      class="survey-card new-survey-card"
      (click)="createNewSurvey()"
    >
      <mat-card-header>
        <div class="add-icon-container">
          <mat-icon mat-card-avatar class="add-icon" fontSet="material-icons"
            >add_24px</mat-icon
          >
        </div>

        <mat-card-title class="survey-title" i18n="@@app.labels.createSurvey"
          >Create survey</mat-card-title
        >

        <mat-card-subtitle
          class="survey-description"
          i18n="@@app.labels.createSurveyDescription"
          >Define jobs and sites for data collectors</mat-card-subtitle
        >
      </mat-card-header>
    </mat-card>

    <mat-card
      appearance="raised"
      *ngFor="let survey of surveys(); let i = index"
      id="survey-card-{{ i }}"
      class="survey-card"
      (click)="handleSurveySelection(survey)"
    >
      <mat-card-header>
        <mat-icon mat-card-avatar class="add-icon general-access-icon">
          <ng-container [ngSwitch]="survey.generalAccess">
            <ng-container *ngSwitchCase="SurveyGeneralAccess.RESTRICTED"
              >lock</ng-container
            >
            <ng-container *ngSwitchCase="SurveyGeneralAccess.UNLISTED"
              >account_circle</ng-container
            >
            <ng-container *ngSwitchDefault>public</ng-container>
          </ng-container>
        </mat-icon>

        <mat-card-title class="survey-title">{{ survey.title }}</mat-card-title>

        <mat-card-subtitle class="survey-description">
          {{ survey.description }}
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
  </div>
</div>

<ng-template #filterChip let-filter="filter" let-icon="icon">
  <mat-chip
    *ngIf="filterCounters().get(filter)"
    [disabled]="currentFilter() === filter"
    (click)="handleFilterSelection(filter)"
  >
    <mat-icon *ngIf="icon || currentFilter() === filter" matChipAvatar>
      {{ currentFilter() !== filter ? icon : 'check' }}
    </mat-icon>

    <span *ngIf="filter === SurveyListFilter.ALL" i18n="@@app.labels.all"
      >All</span
    >
    <span
      *ngIf="filter === SurveyListFilter.RESTRICTED"
      i18n="@@app.labels.restricted"
      >Restricted</span
    >
    <span
      *ngIf="filter === SurveyListFilter.UNLISTED"
      i18n="@@app.labels.unlisted"
      >Anyone with the link</span
    >
    <span *ngIf="filter === SurveyListFilter.PUBLIC" i18n="@@app.labels.public"
      >Public</span
    >
  </mat-chip>
</ng-template>
